var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningOutlineIcon = function SvgWarningOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 5.02855C13.5274 5.02855 13.9622 5.42562 14.0216 5.93716L14.0285 6.05712V14.5428C14.0285 15.1109 13.568 15.5714 12.9999 15.5714C12.4724 15.5714 12.0377 15.1743 11.9783 14.6628L11.9714 14.5428V6.05712C11.9714 5.48905 12.4319 5.02855 12.9999 5.02855Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 16.5999L13.1361 16.6064C13.8533 16.6749 14.4142 17.2791 14.4142 18.0142C14.4142 18.7953 13.781 19.4285 12.9999 19.4285C12.2188 19.4285 11.5856 18.7953 11.5856 18.0142C11.5856 17.2791 12.1465 16.6749 12.8637 16.6064L12.9999 16.5999Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 0.399902C6.04111 0.399902 0.399902 6.04111 0.399902 12.9999C0.399902 19.9587 6.04111 25.5999 12.9999 25.5999C19.9587 25.5999 25.5999 19.9587 25.5999 12.9999C25.5999 6.04111 19.9587 0.399902 12.9999 0.399902ZM12.9999 2.45705C18.8225 2.45705 23.5427 7.17724 23.5427 12.9999C23.5427 18.8226 18.8225 23.5428 12.9999 23.5428C7.1772 23.5428 2.45701 18.8226 2.45701 12.9999C2.45701 7.17724 7.1772 2.45705 12.9999 2.45705Z",
    fill: "#666666"
  })));
};
export default SvgWarningOutlineIcon;